import * as api from './upFile-api'
import { deepCopy, timeFilter } from '@/untils/untils.js'
import AboutUs from '@/components/aboutUs.vue'

export default {
    components: {
        AboutUs
    },
    data() {
        return {

            // header
            isMobileFlag: false,
            // table
            tableData: [{}],
            pageSize: 10,
            currPage: 1,
            total: 0,
            /* 上传文件列表 */
            fileList: [],
            // dialog
            dialogVisible: false,
            isOver: false,

            /* 表单验证规则 */
            dialogInfo: {},
            fileInfo: {
                "tbiDocumentAmount": "",                //金额
                "tbiDocumentPath": "",                 //文件路径
            },
            fileData: {},
            queryInfo: {},
            /* 倒计时定时器 */
            timer: '',
            countTime: '',  //倒计时时间  
            result: '否',     //
            tips: ` 在报价结束时间前可修改报价进行竞价，规则如下：
      1. 仅能上浮1次报价，上浮金额无限制；
      2. 下调报价无次数限制，下浮金额至少1%；
      3. 请时刻关注竞价系统是否最低价等提示，进行及时调整价格操作。`
        }
    },
    watch: {
        pageSize(val) {
            this.currPage = 1
            this.findProjectList()
        }
    },
    mounted() {
        let params = this.getLocationParams()
        this.queryInfo = params
        let query = {
            currPage: this.currPage,
            pageSize: this.pageSize
        }
        query = { ...query, ...params }
        this.findProjectList(query)
        /* 查询是否手机端 */
        let isMobileFlag = this._isMobile()
        this.isMobileFlag = isMobileFlag ? isMobileFlag[0] === "Android" || isMobileFlag[0] === "iPhone" : false
    },
    methods: {

        /* api */
        prePage() {    // 查

        },
        findProjectList(params) {
            api.findProjectList(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    let originData = d.dataList.map(t => {
                        let binding = t.a01BiddingInfoList.map(item => {
                            if (item.tbiState == '1') return item
                        })[0]
                        t.a01BiddingInfo = binding
                        return t
                    })
                    this.fileData = originData.map(t => {
                        return { ...t, ...t.a01BiddingInfo }
                    })[0]
                    this.startCountDown(this.fileData)
                    console.log(this.fileData);
                    this.fileInfo.tbiDocumentAmount = this.fileData.tbiDocumentAmount ? this.fileData.tbiDocumentAmount : ''
                    this.refreshLowestPrice()
                    let { tbiId } = this.fileData
                    let params = { ...this.queryInfo, tbiId }
                    this.findBiddingSupplierDoc(params)
                }
            })
        },

        findBiddingSupplierDoc(params) {               //查询供应商附件
            api.findBiddingSupplierDoc(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.fileList = d.map(t => {
                        return {
                            name: t.tbiDocumentPath,
                            url: t.tbiDocumentPath
                        }
                    })
                }
            })
        },
        /* 查询是否最低价 */
        findLowestPrice(params) {
            api.findLowestPrice(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.result = d
                    this.$message.info('查询是否最低价成功')
                }
            })
        },

        /* handle */
        openModify(row) {
            let d = deepCopy(row)
            this.detailDialogVisible = true
            this.dialogInfo = d
            this.dialogTableData = d.a01BiddingInfoList
        },
        openDetailDialog() { },
        closeDetailDialog() { },
        /* 上传文件 */
        uploadFile(params) {
            const formdata = new FormData()
            const file = params.file
            let type = '.' + file.name.split('.').pop()
            if (type === '.txt') {
                this.$message.warning('不支持txt文件')
                this.fileList = []
                return
            }
            const name = file.name
            if (name.includes(',')) {
                this.$message.warning('文件名不能包含逗号')
                this.fileList = []
                return
            }
            formdata.append('file', file)
            api.filesUpload(formdata)
                .then(data => {
                    if (data.data.resultObject == 200) {
                        this.$message({ message: '新增成功', type: 'success', });
                    }
                    const file = data.data.resultObject
                    this.fileInfo.tbiDocumentPath = file
                    this.fileList.push({ name: file, url: file })
                }).catch((err) => { })
        },
        /* 上传标书记录表 */
        uploadDocument(params) {
            api.uploadDocument(params).then(data => {
                if (data) {
                    let d = data.data.resultObject
                    this.refreshLowestPrice()
                    this.$message({
                        type: 'success',
                        duration: 15000,
                        message: '操作成功'
                    })
                }
            })
        },
        submitFileInfo() {
            let nowDate = +new Date()
            let start = +new Date(this.fileData.tbiStart)
            let end = +new Date(this.fileData.tbiEnd)
            if (nowDate < start) return this.$message.warning('招标尚未开始')
            if (nowDate > end) return this.$message.warning('招标已经结束')
            this.fileInfo.tbiDocumentPath = this.fileList.map(t => t.url).join(',')
            let { tbiDocumentPath, tbiDocumentAmount } = this.fileInfo
            if (!tbiDocumentPath) return this.$message.warning('请上传附件后在提交')
            if (!tbiDocumentAmount) return this.$message.warning('请输入报价后在提交')
            let reg = /^\d+(.\d+)?$/
            let res = reg.test(this.fileInfo.tbiDocumentAmount)
            if (!res) return this.$message.warning('报价只能输入数字和小数点')
            let params = this.queryInfo
            params = { ...params, ...this.fileInfo }
            params.tbiId = this.fileData.tbiId
            console.log(params);
            this.uploadDocument(params)
            this.dialogVisible = false
        },
        closeFileDialog() {
            this.fileList = []
            this.fileInfo = {
                "tbiDocumentAmount": "",                //金额
                "tbiDocumentPath": "",                 //文件路径
            }
        },
        /* 关于我们 */
        aboutUs() {
            this.dialogVisible = true
        },
        // 索引
        /* hanle upload */
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileList = fileList
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前只能上传 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        indexMethod(index) {
            return (this.currPage - 1) * this.pageSize + index + 1
        },
        getLocationParams() {
            let params = {}
            let hash = location.hash
            let paramsStr = hash.split('?')[1]
            let paramsArr = paramsStr.split('&')
            paramsArr.map(t => {
                let key = t.split('=')[0]
                let value = decodeURIComponent(t.split('=')[1])
                params[key] = value
            })
            return params
        },
        /* 开始倒计时 */
        startCountDown(data) {
            this.countDown(data)
            this.timer = setInterval(() => {
                this.countDown(data)
            }, 1000);

        },
        /* 倒计时 */
        countDown(data) {
            //获取当前时间  
            let now = +new Date()
            //设置截止时间  
            let str = data.tbiEnd.replace(/-/g, '/')
            let end = +new Date(str)
            //时间差  
            let leftTime = end - now;
            //定义变量 d,h,m,s保存倒计时的时间  
            let d, h, m, s;
            if (leftTime >= 0) {
                d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
                m = Math.floor(leftTime / 1000 / 60 % 60);
                s = Math.floor(leftTime / 1000 % 60);
                this.countTime = `${d}天${h}小时${m}分钟${s}秒`
            } else {
                clearInterval(this.timer)
                this.countTime = '本轮招标已经结束'
            }
        },
        /* 查询是否最低价 */
        refreshLowestPrice() {
            let params = this.queryInfo
            params.tbiId = this.fileData.tbiId
            this.findLowestPrice(params)
        },

        // 适配手机端
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        }

    },
}